import { createStyles, makeStyles, Typography } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import { SubscriptionState } from "@onpreo/database/src/interfaces/stripe";
import Link from "next/link";
import { useReduxSelector } from "../../store/selectors";
import { getWorkspaceBillingSubscriptionState } from "../../store/selectors/workspace.selectors";
import { Fragment } from "react";

const useStyles = makeStyles(theme =>
    createStyles({
        banner: {
            width: "100%",
            background: theme.palette.warning.main,
            marginTop: 76,
            marginBottom: -76,
            padding: "12px 0",
            display: "flex",
            justifyContent: "center",
            color: "white"
        },
        // trialBanner: {
        //     width: "100%",
        //     background: theme.palette.info.main,
        //     marginTop: 76,
        //     marginBottom: -76,
        //     padding: "12px 0",
        //     display: "flex",
        //     justifyContent: "center",
        //     color: "black"
        // },
        message: {
            // color: "white",
            marginLeft: 64,
            fontSize: 16
        },
        link: {
            textDecoration: "underline",
            color: "white"
        }
    })
);

const stateText = {
    [SubscriptionState.UNPAID]: "Ihre Rechnung wurde nicht bezahlt. Ihr Konto wird bald gesperrt.",
    [SubscriptionState.PAST_DUE]: "Ihre Rechnung ist überfällig.",
    [SubscriptionState.INCOMPLETE]: "Ihre Rechnungszahlung ist unvollständig.",
    [SubscriptionState.INCOMPLETE_EXPIRED]: "Ihre Rechnungszahlung ist unvollständig.",
    [SubscriptionState.PENDING]: "Ihre Rechnungszahlung ist ausstehend."
    // [SubscriptionState.ACTIVE]: "ACTIVE.",
    // [SubscriptionState.TRIALING]: "Ihre Rechnung wurde nicht bezahlt."
};

const SubscriptionStateBanner = () => {
    const classes = useStyles();
    const subState: SubscriptionState = useReduxSelector(getWorkspaceBillingSubscriptionState);

    return (
        <Fragment>
            {!!subState && Object.keys(stateText).includes(subState) && (
                <div className={classes.banner}>
                    <Typography align="center" className={classes.message}>
                        {stateText[subState]}
                        {" Bei SEPA-Lastschrift kann es 3-4 Tage dauern bis wir Ihre Zahlung erhalten."}
                        <Link className={classes.link} href={"/billing"}>
                            <br />
                            Sind Ihre Zahlungsinformationen noch aktuell?
                            <ChevronRight style={{ width: 20, height: 20 }} />
                        </Link>
                    </Typography>
                </div>
            )}
        </Fragment>
    );
};

export default SubscriptionStateBanner;
